import { Root } from '@radix-ui/react-collapsible'

export const Collapsible = Root
